var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z-site-selector"},[_vm._l((_vm.list),function(item){return [(!item.active)?_c('a',{key:item.lid,staticClass:"z-site-selector__site",class:{ 'z-site-selector__site--invert' : _vm.invertColor },attrs:{"href":item['path-changed']}},[_c('span',{domProps:{"innerHTML":_vm._s(item.lang)}})]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }